export class ImplementDetails {
    public condition: number = 0;
    public customer: string = "";
    public jobsite: string = "";
    public jobsiteId: number = 0;
    public make: string = "";
    public model: string = "";
    public life: number = 0;
    public implementType: string = "";
    public serialNo: string = "";
    public lastInspection: string = "";
    public status: string = "";
    public repairerName: string = "";
  public workshopName: string = "";
  public SinglePointCrackEntry: boolean = false;
}

export class EquipmentDetails {
    public id: number = 0;
    public serialno: string = "";
    public unitno: string = "";
    public site_name: string = "";
    public meter_reading: number = 0;
    public ltd: number = 0;
    public makedesc: string = "";
    public modeldesc: string = "";
    public typedesc: string = "";
    public setup_date: string = "";
}

export class InspectionDetails {
    public id: number = 0;
    public condition: number = 0;
    public inspectionDate: string = "";
    public inspector: string = "";
    public life: number = 0;
}

export class ComponentDetails {
    public componentId: number = 0;
    public condition: number = 0;
    public component: string = "";
    public part_number: string = "";
    public make: string = "";
    public cost: number = 0;
    public life: number = 0;
}

export class ImplementHistory {
    public date: string = "";
    public implement_life: string = "";
    public component: string = "";
    public component_life: string = "";
    public action_taken: string = "";
    public cost: number = 0;
    public comment: string = "";
}
export class LastInspectionDetailsForImplementModel {
    public ImplementId : number;
    public SMU :number;
    public InspectioDate : Date;
  }
